import React, { useEffect, useState } from 'react';
import { FaArrowUp } from 'react-icons/fa';
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
    const [visible, setVisible] = useState(false);
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    useEffect(() => {
        const toggleVisibility = () => {
            if (window.scrollY > 300) {
                setVisible(true);
            } else {
                setVisible(false);
            }
        };
        window.addEventListener("scroll", toggleVisibility);
        return () => window.removeEventListener("scroll", toggleVisibility);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };

    return (
        visible && (
            <div
                onClick={scrollToTop}
                style={{
                    position: "fixed",
                    bottom: "40px",
                    right: "30px",
                    zIndex: 999,
                }}
                title="Scroll to top"
            >
                <FaArrowUp className='footer-i' />
            </div>
        )
    );
};

export default ScrollToTop;
